export const EMAIL_ADDRESS = 'support@manifesteem.com';

export const API_HOST_MANIFESTEEM = import.meta.env.VITE_API_HOST_MANIFESTEEM;

export const GROWTHBOOK_API_HOST = import.meta.env.VITE_GROWTH_BOOK_API_HOST;

export const ACCESS_TOKEN_KEY = 'access_token';

export const PLATFORM_HOST = import.meta.env.VITE_PLATFORM_HOST;

export const FUNNELS_HOST = import.meta.env.VITE_FUNNELS_HOST;
